<template>
  <div class="indexAdminLogin_return" @click="closeToken">
    <div>
      <el-icon><ArrowLeft /></el-icon>
    </div>
    <div style="margin-top: -3px">
      <span>返回</span>
    </div>
  </div>
  <div class="indexAdminLogin_selectLessee" v-if="showData.lesseeMainUserLesseeList.length>0 && showData.showState==true">
    <div class="indexAdminLogin_selectLessee_title">选择你管理的组织</div>
    <div class="indexAdminLogin_selectLessee_remake">你在以下组织中担任管理员</div>
    <div>
      <el-scrollbar max-height="350px">
        <div class="indexAdminLogin_selectLessee_list" v-for="(item,index) in showData.lesseeMainUserLesseeList" v-bind:key="index" @click="seletcLesseeClick(item)">
          <div class="indexAdminLogin_selectLessee_list_img">
            <img src="@/assets/indexLogin_lessee.png" v-if="item.lesseeLogo==null">
            <img :src="item.lesseeLogo.systemFileUrl" v-else>
          </div>
          <div class="indexAdminLogin_selectLessee_list_title">{{ item.lesseeName }}</div>
          <div class="indexAdminLogin_selectLessee_list_right"><el-icon><Right /></el-icon></div>
          <div style="clear: both"></div>
        </div>
      </el-scrollbar>
    </div>
  </div>
  <div v-if="showData.lesseeMainUserLesseeList.length==0 && showData.showState==true">
    <div  class="indexAdminLogin_selectLessee_no_img">
      <img src="@/assets/indexLogin_addLessee_img.png" alt="" >
    </div>
    <div  class="indexAdminLogin_selectLessee_no_title">
      该账号不是管理员
    </div>
    <div  class="indexAdminLogin_selectLessee_no_text">
      <p>仅支持管理员登录，未找到该账号担任管理员的组织，你可选择：</p>

      <p>1.联系组织管理员为你添加管理权限</p>
      <p>2.直接创建新组织，成为管理员</p>
      <p>3.更换账号重新登录</p>
    </div>
  </div>
<!--  <div class="indexAdminLogin_addLessee_text" @click="addLesseeClick">创建企业/组织/团队</div>-->
</template>

<script setup>
import {onMounted, reactive, defineExpose, defineEmits} from 'vue';
import {requestToken} from '@/util/adminRequest.js';
import store from '@/configure/store';
import router from "@/configure/router";
// 返回上级调用参数
const emits = defineEmits(['childMethod'])
// 初始值
const showData = reactive({
  lesseeMainUserLesseeList: [], // 全部企业列表
  showState:false
});
//跳转到扫码登录
const closeToken = function () {
  emits('childMethod', 'closeToken', "")
}
//切换公司（获取所在租户列表）
const listLesseeMainUserLessee = function () {
  // 获取数据
  requestToken({
    url: '/Api/userSystem/LesseeUserModule/LesseeUser/ListLesseeMainUserLessee',
    data: {}
  }).then(res => {
    showData.lesseeMainUserLesseeList = res.data
    showData.showState=true
  })
}
//跟新登录时间
const updateLesseeUserMeta = function (lesseeUserID) {
  // 获取数据
  requestToken({
    url: '/Api/userSystem/PCLesseeMainModule/LesseeMainUser/UpdateLesseeUserMeta',
    data: {
      lesseeUserID: lesseeUserID
    }
  }).then(res => {
  })
}

//选择公司
const seletcLesseeClick=function (data){
  updateLesseeUserMeta(data.lesseeUserID)
  store.commit('saveLesseeAdminToken', {
    lesseeAdminToken:data.memberLesseeTokenValue,
    lesseeAdminData:data
  })
  verifyLoginState()
  router.push('/')
}

// 校验管理后台登录状态
const verifyLoginState = function () {
  requestToken({
    url: '/Api/userSystem//LesseeMainModule/LesseeMainUserLogin/AuthorityData',
    data: {}
  }).then(res => {
    store.commit('saveUserAuthorityData', {
      authorityData: res.data,
    })
  })
}

//显示添加企业
const addLesseeClick=function (){
  emits('childMethod', 'addLessee', "")
}

// 启动调用
onMounted(() => {
});
//公开方法
defineExpose({listLesseeMainUserLessee});
</script>
<style scoped>
</style>
